module.exports = __webpack_public_path__ + "media/assets/img/flags/az-AZ-01d67e6cc5ea515c45b893d7a339b0a7.png";